import { render, staticRenderFns } from "./BdoCardTemplate.vue?vue&type=template&id=ccfa0d42&scoped=true&"
import script from "./BdoCardTemplate.vue?vue&type=script&lang=js&"
export * from "./BdoCardTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BdoCardTemplate.vue?vue&type=style&index=0&id=ccfa0d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfa0d42",
  null
  
)

export default component.exports